import { TocItem } from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/TableOfContentType';
import { StepType } from '@doltech/ui/lib/figma/Steps/StepsV2';
import { WritingSampleTypeEnum } from '@doltech/utils/lib/constants';

export const writingTask1Step: StepType[] = [
  { name: 'Basic info', status: 'wait' },
  { name: 'Tạo dàn ý', status: 'wait' },
  { name: 'Bài mẫu & Vocab', status: 'wait' },
  { name: 'Tạo Idea', status: 'wait' },
  { name: 'Nhập Vocab', status: 'wait' },
  { name: 'Nhập Exercise', status: 'wait' },
  { name: 'Viết Feedback', status: 'wait' },
  { name: 'Preview', status: 'wait' },
  { name: 'Gán cho ai', status: 'wait' },
];

export const writingTask2AcademicStep: StepType[] = [...writingTask1Step];

export const writingTask1GeneralStep: StepType[] = [
  { name: 'Basic info', status: 'wait' },
  { name: 'Bài mẫu & Vocab', status: 'wait' },
  { name: 'Dịch bài', status: 'wait' },
  { name: 'Nhập Exercise', status: 'wait' },
  { name: 'Preview', status: 'wait' },
  { name: 'Gán cho ai', status: 'wait' },
];

export const getStepBySampleType = (type) => {
  switch (type) {
    case WritingSampleTypeEnum.WRITING_TASK_2_ACADEMIC: {
      return writingTask2AcademicStep;
    }
    case WritingSampleTypeEnum.WRITING_TASK_1_GENERAL: {
      return writingTask1GeneralStep;
    }
    default:
  }
  return writingTask1Step;
};

export const WritingTask1TocId = {
  DE_BAI: 'de-bai',
  DAN_Y: 'dan-y',
  BAI_MAU: 'bai-mau',
  VOCABULARY: 'vocabulary',
  FEEDBACK: 'feedback',
  EXERCISES: 'bai-tap-on-lai',
  LOI_KET: 'loi-ket',
} as const;

export type WritingTask1TocId = (typeof WritingTask1TocId)[keyof typeof WritingTask1TocId];

export const writingTask1TableOfContent: TocItem[] = [
  {
    id: WritingTask1TocId.DE_BAI,
    text: 'Đề bài',
    prefix: '🚀',
  },
  {
    id: WritingTask1TocId.DAN_Y,
    text: 'Dàn ý',
    prefix: '😵',
  },
  {
    id: WritingTask1TocId.BAI_MAU,
    text: 'Bài mẫu',
    prefix: '📝',
  },
  {
    id: WritingTask1TocId.VOCABULARY,
    text: 'Vocabulary',
    prefix: '📚',
  },
  {
    id: WritingTask1TocId.EXERCISES,
    text: 'Bài tập Exercise',
    prefix: '✨',
  },
  {
    id: WritingTask1TocId.FEEDBACK,
    text: 'Feedback from teacher',
    prefix: '📑',
  },
  {
    id: WritingTask1TocId.LOI_KET,
    text: 'Lời kết',
    prefix: '💡',
  },
];

export const WritingTask2GeneralTocId = {
  DE_BAI: 'de-bai',
  BAI_MAU: 'bai-mau',
  PHAN_DICH: 'phan-dich',
  EXERCISES: 'bai-tap-on-lai',
  LOI_KET: 'loi-ket',
} as const;

export type WritingTask2GeneralTocId =
  (typeof WritingTask2GeneralTocId)[keyof typeof WritingTask2GeneralTocId];

export const writingTask2GeneralTableOfContent: TocItem[] = [
  {
    id: WritingTask2GeneralTocId.DE_BAI,
    text: 'Đề bài',
    prefix: '🚀',
  },
  {
    id: WritingTask2GeneralTocId.BAI_MAU,
    text: 'Bài mẫu',
    prefix: '📝',
  },
  {
    id: WritingTask2GeneralTocId.PHAN_DICH,
    text: 'Phần dịch',
    prefix: '📄',
  },
  {
    id: WritingTask2GeneralTocId.EXERCISES,
    text: 'Bài tập Exercise',
    prefix: '✨',
  },
  {
    id: WritingTask2GeneralTocId.LOI_KET,
    text: 'Lời kết',
    prefix: '💡',
  },
];

export const WritingTask2AcademicTocId = {
  DE_BAI: 'de-bai',
  DAN_Y: 'dan-y',
  BAI_MAU: 'bai-mau',
  VOCABULARY: 'vocabulary',
  FEEDBACK: 'feedback',
  EXERCISES: 'bai-tap-on-lai',
  LOI_KET: 'loi-ket',
} as const;

export type WritingTask2AcademicTocId =
  (typeof WritingTask2AcademicTocId)[keyof typeof WritingTask2AcademicTocId];

export const writingTask2AcademicTableOfContent: TocItem[] = [
  {
    id: WritingTask2AcademicTocId.DE_BAI,
    text: 'Đề bài',
    prefix: '🚀',
  },
  {
    id: WritingTask2AcademicTocId.DAN_Y,
    text: 'Dàn ý',
    prefix: '😵',
  },
  {
    id: WritingTask2AcademicTocId.BAI_MAU,
    text: 'Bài mẫu',
    prefix: '📝',
  },
  {
    id: WritingTask2AcademicTocId.VOCABULARY,
    text: 'Vocabulary',
    prefix: '📚',
  },
  {
    id: WritingTask2AcademicTocId.EXERCISES,
    text: 'Bài tập Exercise',
    prefix: '✨',
  },
  {
    id: WritingTask2AcademicTocId.FEEDBACK,
    text: 'Feedback from teacher',
    prefix: '📑',
  },
  {
    id: WritingTask2AcademicTocId.LOI_KET,
    text: 'Lời kết',
    prefix: '💡',
  },
];
